<template>
    <div class="container lnb d_container">
        <div class="contents_wrap">
            <div class="contents list-container">
                <div class="title">
                    컬렉션 상세정보
                </div>
                <div class="write_tab">
                    <div class="write_tab_content tab_payment_detail" @click="movePage()">
                        상세정보
                    </div>
                    <div class="write_tab_content tab_payment_detail active">
                        아이템
                    </div>
                  <div class="write_tab_content tab_payment_detail"
                       @click="moveUtility()">
                    유틸리티
                  </div>
                </div>
                <div class="member_write_wrap">
                    <div class="write_content">
                        <div class="write_box">
                         <item-list-component :item-type="'collectionDetailItemList'" :collection-key="itemKey"></item-list-component>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import ItemWriteComponent from "@/components/item/ItemWriteComponent";
import EventBus from "@/utils/event-bus";
import ItemWriteCollectionComponent from "@/components/item/ItemWriteCollectionComponent";
import ItemListComponent from "@/components/item/ItemListComponent";

export default {
    name: "ItemCollectionDetailItem",
    mixins: [],
    components: {
        ItemListComponent,
        ItemWriteCollectionComponent,
        ItemWriteComponent
    },
    inject: [],
    provide() {
        return {}
    },
    props: {},
    data() {
        return {
            itemKey: this.$route.params.idx
        }
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {

    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        writeItem() {
            EventBus.$emit('writeCollection')
        },
        movePage() {
            this.$router.push(`/item/collection/${this.itemKey}`)
        },
      moveUtility() {
        this.$router.push(`/item/collection/${this.itemKey}/utility`)
      },
    },
    watch: {},
}
</script>

<style scoped>

</style>
